import _ from 'lodash'
import moment from 'moment-timezone'
import { getToken, isSuperAdmin as hasSuperAdminAccess, hasViewOnlyAccess, isAdmin } from '../../utils/helper'
import * as CONSTANTS from '../../Constants/ActionTypes'
import * as MESSAGES from '../../Constants/MessagesConstant'
import * as MESSAGETYPES from '../../utils/messageTypes'

let initialState = {
  authUser: getToken(),
  currentUser: '',
  message: '',
  messageType: 'info',
  stateList: '',
  loading: false,
  accountId: '',
  isSuperAdmin: false,
  isViewOnly: false,
  isAdmin: false,
  timeZone: moment.tz.guess(),
  errorResponse: ''
}

export default (state = initialState, action) => {
  switch (action.type) {
    case CONSTANTS.SIGNUP_USER:
      return { ...state, loading: true }
    case CONSTANTS.USER_SIGNUP_SUCCESS:
      return {
        ...state,
        message: MESSAGES.SIGNUP_SUCCESS,
        messageType: MESSAGETYPES.SUCCESS,
        loading: false
      }
    case CONSTANTS.USER_SIGNUP_FAILED:
      return {
        ...state,
        message: action.message || MESSAGES.SOMETHING_WENT_WRONG,
        messageType: MESSAGETYPES.ERROR,
        loading: false
      }
    case CONSTANTS.SIGNIN_USER:
      return { ...state, loading: true }
    case CONSTANTS.USER_SIGNIN_SUCCESS:
      return {
        ...state,
        message: MESSAGES.SIGNIN_SUCCESS,
        authUser: action.payload['GS-Authorization'],
        currentUser: action.payload,
        messageType: MESSAGETYPES.SUCCESS,
        accountId: _.get(action.payload, 'account_id', ''),
        isSuperAdmin: hasSuperAdminAccess(_.get(action.payload, 'roles', [])),
        isViewOnly: hasViewOnlyAccess(_.get(action.payload, 'roles', [])),
        isAdmin: isAdmin(_.get(action.payload, 'roles', [])),
        timeZone: _.get(action.payload, 'account_time_zone', moment.tz.guess()),
        loading: false
      }
    case CONSTANTS.USER_SIGNIN_FAILED:
      return {
        ...state,
        message: MESSAGES.SIGNIN_FAILED,
        messageType: MESSAGETYPES.ERROR,
        errorResponse: action.payload,
        loading: false
      }
    case CONSTANTS.USER_SERVER_DOWN:
      return {
        ...state,
        message: MESSAGES.SERVER_DOWN,
        messageType: MESSAGETYPES.ERROR,
        errorResponse: action.payload,
        loading: false
      }
    case CONSTANTS.USER_SIGNOUT_SUCCESS:
      return { ...state, authUser: '', message: '', errorResponse: '' }
    case CONSTANTS.USER_SIGNOUT_FAILED:
      return { ...state, authUser: '', message: '', errorResponse: '' }
    case CONSTANTS.PASSWORD_CHANGE:
      return { ...state, loading: true }
    case CONSTANTS.PASSWORD_CHANGE_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload,
        messageType: MESSAGETYPES.SUCCESS,
      }
    case CONSTANTS.PASSWORD_CHANGE_FAILED:
      return {
        ...state,
        loading: false,
        message: action.payload,
        messageType: MESSAGETYPES.ERROR,
      }
    case CONSTANTS.GET_CURRENT_USER_SUCCESS:
      return {
        ...state,
        currentUser: action.payload,
        accountId: _.get(action.payload, 'account_id', ''),
        isSuperAdmin: hasSuperAdminAccess(_.get(action.payload, 'roles', [])),
        isViewOnly: hasViewOnlyAccess(_.get(action.payload, 'roles', [])),
        isAdmin: isAdmin(_.get(action.payload, 'roles', [])),
        timeZone: _.get(action.payload, 'account_time_zone', moment.tz.guess())
      }
    case CONSTANTS.CLEAR_MESSAGE:
      return {
        ...state,
        message: '',
        messageType: ''
      }
    default:
      return state
  }
}
